import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import PainSection from "../components/PainSection";
import BeforeAfter from "../components/BeforeAfter";
import WhatsInside from "../components/WhatsInside";
import HowItWorks from "../components/HowItWorks";
import DynamicSchema from "../components/DynamicSchema";
import Testimonials from "../components/Testimonials";
import FinalCta from "../components/FinalCta";
import Faq from "../components/Faq";
import Footer from "../components/Footer";
import StickyMobileCta from "../components/StickyMobileCta";

export default function Landing() {
  return (
    <main
      data-testid="landing-page"
      className="bg-obsidian text-ink-50 selection:bg-gold/30 font-body"
    >
      <Header />
      <Hero />
      <PainSection />
      <BeforeAfter />
      <WhatsInside />
      <HowItWorks />
      <DynamicSchema />
      <Testimonials />
      <FinalCta />
      <Faq />
      <Footer />
      <StickyMobileCta />
    </main>
  );
}
